import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

export default function NotFound() {
    const { t } = useTranslation();

    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                {t('notFound.title')}
            </Header>
            <Segment.Inline>
                <Button as={Link} to='/games' primary>
                    {t('notFound.returnToGames')}
                </Button>
            </Segment.Inline>
        </Segment>
    )
}